module.exports = __webpack_public_path__ + "img/q80_1.e05896db.png";